import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class Newsletter {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <section class="fg-hero fg-newsletter-form">
                <h2 class="fg-hero__title">Join Our Newsletter</h2>
                <p class="fg-hero__text">
                    Get the latest news, updates, and insights from the world of women's football
                    delivered directly to your inbox. Stay connected with the beautiful game!
                </p>
                <form id="fg-newsletter-form">
                    <div class="fg-field">
                        <input type="text" id="fg-news-name" class="fg-input" placeholder="Your Name" required>
                    </div>
                    <div class="fg-field">
                        <input type="email" id="fg-news-email" class="fg-input" placeholder="Your Email Address" required>
                    </div>
                    <button type="submit" class="fg-btn fg-btn--white">Subscribe Now</button>
                </form>
            </section>

            <div class="fg-grid">
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">📰</div>
                    <h3 class="fg-service-card__title">Latest News</h3>
                    <p class="fg-service-card__desc">
                        Get breaking news, transfer updates, and match reports from leagues
                        around the world, delivered fresh to your inbox.
                    </p>
                </article>
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">🎯</div>
                    <h3 class="fg-service-card__title">Exclusive Content</h3>
                    <p class="fg-service-card__desc">
                        Access exclusive interviews, behind-the-scenes content, and in-depth
                        analysis that you won't find anywhere else.
                    </p>
                </article>
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">⚽</div>
                    <h3 class="fg-service-card__title">Match Previews</h3>
                    <p class="fg-service-card__desc">
                        Detailed match previews, team analysis, and predictions for upcoming
                        games in major women's leagues and tournaments.
                    </p>
                </article>
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">🏆</div>
                    <h3 class="fg-service-card__title">Tournament Coverage</h3>
                    <p class="fg-service-card__desc">
                        Comprehensive coverage of international tournaments, World Cups,
                        continental championships, and more.
                    </p>
                </article>
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">👥</div>
                    <h3 class="fg-service-card__title">Player Spotlights</h3>
                    <p class="fg-service-card__desc">
                        Learn about rising stars, established players, and the stories behind
                        the athletes who make the game special.
                    </p>
                </article>
                <article class="fg-card">
                    <div class="fg-service-card__icon" aria-hidden="true">📊</div>
                    <h3 class="fg-service-card__title">Statistics &amp; Analysis</h3>
                    <p class="fg-service-card__desc">
                        Data-driven insights, statistics, and analysis to help you understand
                        the game at a deeper level.
                    </p>
                </article>
            </div>

            <section class="fg-sample-block">
                <h2 class="fg-section-title">What You'll Receive</h2>
                <p class="fg-prose">
                    Our newsletter is delivered weekly and includes a curated selection of the most
                    important stories, exclusive content, and insights from the world of women's football.
                    Whether you're a die-hard fan, casual observer, or industry professional, our
                    newsletter has something for everyone interested in the beautiful game.
                </p>
            </section>
        `;

        el.innerHTML = sidebarPage({
            title: 'Newsletter',
            subtitle: "Stay updated with the latest in women's football",
            main,
            wide: true
        });

        el.querySelector('#fg-newsletter-form')?.addEventListener('submit', (e) => {
            e.preventDefault();
            const name = el.querySelector('#fg-news-name')?.value?.trim() || '';
            const email = el.querySelector('#fg-news-email')?.value?.trim() || '';
            window.alert(
                `Thank you, ${name}! You've been successfully subscribed to our newsletter. We'll send updates to ${email}.`
            );
            e.target.reset();
        });
    }
}
